import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMUnderlyingsEdit } from "./edit";
import { A7OPCVMUnderlyingsTable } from "./table";

export default function A7OPCVMUnderlyings() {
  useEffect(() => {
    setDocumentTitle("Quantilia | OPCVM Instruments Financiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMUnderlyingsEdit />} />
      <Route index element={<A7OPCVMUnderlyingsTable />} />
    </Routes>
  );
}
